import { useMutation } from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  GetInstallmentOrderPaymentDetailsRequestSchema,
  GetInstallmentOrderPaymentDetailsRequestType,
  GetInstallmentOrderPaymentDetailsResponseSchema,
  GetInstallmentOrderPaymentDetailsResponseType
} from '../../../services/IbInstallmentsServices/APIService/types';

import { useIbInstallmentsService } from '../useIbInstallmentsService';

interface UseGetInstallmentOrderPaymentDetailsApiInterface {
  getInstallmentOrderPaymentDetailsApi: (
    input: GetInstallmentOrderPaymentDetailsRequestType
  ) => Promise<GetInstallmentOrderPaymentDetailsResponseType>;
  isLoading: boolean;
  isError: boolean;
  error: string | null;
  status: 'idle' | 'loading' | 'success' | 'error';
  reset: () => void;
}

const useGetInstallmentOrderPaymentDetailsApi =
  (): UseGetInstallmentOrderPaymentDetailsApiInterface => {
    const { ibInstallmentsServiceInstance } = useIbInstallmentsService();

    const getInstallmentOrderPaymentDetails = (
      requestObject: GetInstallmentOrderPaymentDetailsRequestType
    ) => {
      try {
        // Always validate request object against schema
        GetInstallmentOrderPaymentDetailsRequestSchema.parse(requestObject);
      } catch (error) {
        console.error('Invalid request object:', error);
        throw error;
      }

      return ibInstallmentsServiceInstance
        .getInstallmentOrderPaymentDetails(requestObject)
        .then((response) => {
          try {
            // Always validate response against schema
            GetInstallmentOrderPaymentDetailsResponseSchema.parse(response);
          } catch (error) {
            console.error('Invalid response object:', error);
            throw error;
          }
          return response;
        });
    };

    const { mutateAsync, isLoading, isError, error, status, reset } =
      useMutation(getInstallmentOrderPaymentDetails, {
        mutationKey: ['getInstallmentOrderPaymentDetailsApi']
      });

    return {
      getInstallmentOrderPaymentDetailsApi: mutateAsync,
      isLoading,
      isError,
      error: error ? getAPIErrorMessage(error) : null,
      status,
      reset
    };
  };

export { useGetInstallmentOrderPaymentDetailsApi };
